import { render, staticRenderFns } from "./LayoutBreadcrumb.vue?vue&type=template&id=0536c61f&scoped=true"
import script from "./LayoutBreadcrumb.vue?vue&type=script&lang=js"
export * from "./LayoutBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./LayoutBreadcrumb.vue?vue&type=style&index=0&id=0536c61f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536c61f",
  null
  
)

export default component.exports